export const locale = {
    lang: 'fr',
    data: {
        MOVE_CARDS: 'Export de cartes vers une activité',
        SELECTION: 'Sélection',
        ACTIVITY: 'Activité',
    }
};
